import { gql } from "@apollo/client";
const GET_PACKAGES = gql`
  query getAllStripeProducts {
    getAllStripeProducts(connectedAccountId: "acct_1OKbGGBNPNagASFr")
  }
`;

export default GET_PACKAGES;
